import { useI18n } from '../../i18n';
import { translateDivisionLabel, translateRoundLabel } from '../../i18n/labels';

function PlayerStatus({ player }) {
  const { t } = useI18n();
  if (!player) return null;
  const hasScore = player.totalScore != null;
  return (
    <span className="live-panel-player">
      {player.name}
      <span className={`live-checkin${player.checkedIn ? ' live-checkin-on' : ''}`}>
        {player.checkedIn ? t('bracket.live.checkedIn') : t('bracket.live.waiting')}
      </span>
      {hasScore && (
        <span>
          {t('bracket.live.points', { score: player.totalScore })}
          {player.result === 'WIN'
            ? t('bracket.live.win')
            : player.result === 'LOSE'
              ? t('bracket.live.loss')
              : player.result === 'DRAW'
                ? t('bracket.live.draw')
                : ''}
        </span>
      )}
    </span>
  );
}

/** 경기 이름: (다른 대회면 대회명 ·) 부문 · N번 라운드 */
export function formatLiveMatchLabel(t, live, selectedTournamentId) {
  const otherTournament = String(live.tournamentId) !== String(selectedTournamentId);
  return [
    otherTournament ? live.tournamentName : null,
    live.divisionLabel ? translateDivisionLabel(live.divisionLabel) : null,
    `${t('bracket.matchNo', { no: live.matchNumber })} ${translateRoundLabel(live.roundLabel) ?? ''}`.trim(),
  ]
    .filter(Boolean)
    .join(' · ');
}

/** VR 진행 중인 경기 (관리자). 코트마다 1경기, 모든 대회 */
function LiveMatchPanel({ liveMatches, selectedTournamentId, onEnd }) {
  const { t } = useI18n();
  if (!liveMatches?.length) {
    return (
      <section className="live-panel live-panel-idle" aria-label={t('bracket.live.panelAria')}>
        <span className="live-panel-label">{t('bracket.live.idle')}</span>
        <p className="live-panel-hint">{t('bracket.live.idleHint')}</p>
      </section>
    );
  }

  const hasOtherTournament = liveMatches.some(
    (live) => String(live.tournamentId) !== String(selectedTournamentId)
  );
  return (
    <section className="live-panel live-panel-active" aria-label={t('bracket.live.panelAria')}>
      {liveMatches.map((live) => (
        <div key={live.court} className="live-panel-row">
          <span className="live-panel-label">● {t('bracket.live.court', { court: live.court })}</span>
          <span className="live-panel-match">{formatLiveMatchLabel(t, live, selectedTournamentId)}</span>
          <PlayerStatus player={live.player1} />
          <span>vs</span>
          <PlayerStatus player={live.player2} />
          <button
            type="button"
            className="match-live-btn match-live-btn-end"
            onClick={() => onEnd(live.court)}
          >
            {t('bracket.endMatch')}
          </button>
        </div>
      ))}
      {hasOtherTournament && <p className="live-panel-hint">{t('bracket.live.otherTournamentHint')}</p>}
    </section>
  );
}

export default LiveMatchPanel;
